import { render, staticRenderFns } from "./VTag.vue?vue&type=template&id=408407ab&scoped=true"
import script from "./VTag.vue?vue&type=script&lang=ts"
export * from "./VTag.vue?vue&type=script&lang=ts"
import style0 from "./VTag.vue?vue&type=style&index=0&id=408407ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408407ab",
  null
  
)

export default component.exports